var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowerSabotageProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 21.8435C2.95 21.8435 2.47917 21.6477 2.0875 21.256C1.69583 20.8643 1.5 20.3935 1.5 19.8435V15.8435C1.5 15.2935 1.69583 14.8227 2.0875 14.431C2.47917 14.0393 2.95 13.8435 3.5 13.8435H17.5C18.05 13.8435 18.5208 14.0393 18.9125 14.431C19.3042 14.8227 19.5 15.2935 19.5 15.8435V19.8435C19.5 20.3935 19.3042 20.8643 18.9125 21.256C18.5208 21.6477 18.05 21.8435 17.5 21.8435H3.5ZM3.5 19.8435H17.5V15.8435H3.5V19.8435ZM5.025 12.3435L0 9.49351L6 8.49351L4.375 2.61851L9.35 6.14351L12.35 0.843506L13.35 6.84351L19.225 5.21851L15.7 10.1935L19.5 12.3435H15.45L12.8 10.8435L14.35 8.64351L11.75 9.36851L11.3 6.71851L10 9.04351L7.8 7.49351L8.525 10.0935L5.875 10.5435L8.875 12.3435H5.025Z",
    fill: "#FF0953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerSabotageProtection);
export default __webpack_public_path__ + "static/media/tower_sabotage_protection.4c97c4909bbc44cb19e8c12515ed1b70.svg";
export { ForwardRef as ReactComponent };